import React, { useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "./popupsright.css";
import coinImage from "../images/coins.png";

const apiUrl = process.env.REACT_APP_API_URL;

const formatCoins = (value) => Number(value || 0).toLocaleString("ro-RO");
const formatCoinsCompact = (value) => {
  const coins = Number(value || 0);
  if (coins < 1000) return String(coins);
  return `${Math.floor(coins / 1000)}k`;
};

const CoinButtonWithDropdown = () => {
  const btnRef = useRef(null);
  const popupRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [coinsFromStats, setCoinsFromStats] = useState(0);

  useEffect(() => {
    const fetchUserCoins = async () => {
      try {
        const userRes = await fetch(`${apiUrl}/user`, {
          credentials: "include",
        });

        if (!userRes.ok) return;

        const user = await userRes.json();

        if (!user?.user_id) return;

        const statsRes = await fetch(`${apiUrl}/user/${user.user_id}/stats`, {
          credentials: "include",
        });

        if (!statsRes.ok) return;

        const stats = await statsRes.json();
        setCoinsFromStats(Number(stats?.coins ?? 0));
      } catch (error) {
        console.error("Eroare la preluarea user_stats:", error);
      }
    };

    fetchUserCoins();
  }, []);

  // detect mobile / desktop
  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  // inchide popup la click in afara
  useEffect(() => {
    const close = (e) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(e.target) &&
        !btnRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  useEffect(() => {
    if (open) {
      document.body.classList.add("stats-popup-open");
    } else {
      document.body.classList.remove("stats-popup-open");
    }

    return () => {
      document.body.classList.remove("stats-popup-open");
    };
  }, [open]);

  return (
    <div className="first-main-pagi-coin-wrapper">
      {/* BUTON */}
      <div
        ref={btnRef}
        className="first-main-pagi-stats-button"
        onClick={() => setOpen(!open)}
      >
        <img
          src={coinImage}
          alt="coin"
          className="first-main-pagi-stats-icon"
        />
        <div className="first-main-pagi-stats-number">{formatCoinsCompact(coinsFromStats)}</div>
      </div>

      {open && createPortal(
        <>
          <div
            className="first-main-pagi-overlay"
            onClick={() => setOpen(false)}
          />

          <div
            ref={popupRef}
            className={`first-main-pagi-popup first-main-pagi-coin-popup ${
              isMobile ? "mobile" : "desktop"
            }`}
          >
            <div className="first-main-pagi-popup-header">
              <div className="orientation-title-popup-main">
                <img
          src={coinImage}
          alt="coin"
          className="first-main-pagi-stats-icon"
        />
              <p className="distance-coin">Sold monede</p>

              </div>
              
            </div>
            <div className="coin-balance-details">
              <div className="coin-row">
                <span>Sold precedent monede:</span>
                <span className="coin-amount">{formatCoins(coinsFromStats)}</span>
              </div>
              <div className="coin-row">
                <span>Rulat monede:</span>
                <span className="coin-amount">{formatCoins(coinsFromStats)}</span>
              </div>
              <div className="coin-row">
                <span>Sold final monede:</span>
                <span className="coin-amount">{formatCoins(coinsFromStats)}</span>
              </div>
            </div>
           
            <div className="first-main-pagi-popup-item-coins">
              <span className="color-button-streak">Detalii sold</span>
            </div>
          </div>
        </>,
        document.body
      )}
    </div>
  );
};

export default CoinButtonWithDropdown;
